exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".markerTable[data-v-1dac6309]  .el-checkbox{margin:0!important}.markerTable .el-table td[data-v-1dac6309],.markerTable[data-v-1dac6309]  .el-table th.is-leaf{border:none!important}", ""]);

// exports
